import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RecaptchaModule } from "ng-recaptcha";
import { ImportsModule } from "../../../../imports";
import { LenguageSwitcher } from "../../../shared/lenguage-switcher/lenguage-switcher";
import { LoginBaseComponent } from "../login.base.component";
import { ReloginScreenComponent } from "../reloginscreen.component";

@Component({
    standalone: true,
    selector: 'app-login-gcoliva',
    templateUrl: `login.gcoliva.component.html`,
    styleUrls: ['./login.gcoliva.component.scss'],
    imports: [FormsModule, RecaptchaModule, ImportsModule, LenguageSwitcher, ReloginScreenComponent],
})
export class LoginGCOlivaComponent extends LoginBaseComponent {

    logoform = "/assets/cecopin/GISECloud-2.png"
    logoheader = "/assets/cecopin/cecopin-hierro.png"
}